import React from 'react';
import './Modal.css';

const SuccessModal = ({ mensagemSucesso, onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="btn-close" onClick={onClose}>
          &times;
        </button>
        <p>{mensagemSucesso}</p>
      </div>
    </div>
  );
};

export default SuccessModal;